import { render, staticRenderFns } from "./supplier-form.vue?vue&type=template&id=28944f43&"
import script from "./supplier-form.vue?vue&type=script&lang=js&"
export * from "./supplier-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports